/** Electron-only bridge into the trusted main-process computer-control broker. */
export const computerBridge =
  typeof window === "undefined" ? null : (window.desktopBridge?.computer ?? null);
